module.exports = __webpack_public_path__ + "static/4d-2c4b279e8a28532ce47d4a82cac9863e.jpg";